import { MUIDataTableOptions } from "mui-datatables";

export const underwritingOptions: MUIDataTableOptions = {
    download: false,
    sort: false,
    print: false,
    filter: true,
  viewColumns: false,
  rowHover:true,
  responsive:'simple',
    pagination:false,
  selectableRows: "none",
    textLabels: {
      body: {
        toolTip: "",
      },
    },

  };